/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_CreateInputs */

const cs_gdpr_action_create = /** @type {(inputs: Gdpr_Action_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvoření`)
};

const en_gdpr_action_create = /** @type {(inputs: Gdpr_Action_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Gdpr_Action_CreateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_create = /** @type {((inputs?: Gdpr_Action_CreateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_CreateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_create(inputs)
	return cs_gdpr_action_create(inputs)
});